import useColorMode from "@/hooks/useColorMode";

const DarkModeMoon = () => {
  const [colorMode, setColorMode] = useColorMode();

  return (
    <div className="hs-dropdown cursor-pointer">
      <button
        id="hs-dropdown-dark-mode"
        type="button"
        className="hs-dropdown-toggle hs-dark-mode group flex items-center text-stroke hover:text-[#348ddb] focus:outline-none focus:text-[#348ddb] font-medium dark:text-stroke/85 dark:hover:text-stroke dark:focus:text-stroke"
        aria-haspopup="menu"
        aria-expanded="false"
        aria-label="Dropdown"
        onClick={() => {
          if (typeof setColorMode === 'function') {
            setColorMode(colorMode === "light" ? "dark" : "light");
          }
        }}
      >
        {colorMode === "dark" ? (
              <svg
              className="size-5"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
            </svg>
        ) : (
        <svg
            className="size-5"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="4"></circle>
            <path d="M12 2v2"></path>
            <path d="M12 20v2"></path>
            <path d="m4.93 4.93 1.41 1.41"></path>
            <path d="m17.66 17.66 1.41 1.41"></path>
            <path d="M2 12h2"></path>
            <path d="M20 12h2"></path>
            <path d="m6.34 17.66-1.41 1.41"></path>
            <path d="m19.07 4.93-1.41 1.41"></path>
          </svg>
        )}
      </button>
    </div>
  );
};

export default DarkModeMoon;
